var map = {
	"./SpinGeneral_001.webp": 37849,
	"./SpinGeneral_002.webp": 69337,
	"./SpinGeneral_003.webp": 87236,
	"./SpinGeneral_004.webp": 21309,
	"./SpinGeneral_005.webp": 5796,
	"./SpinGeneral_006.webp": 2093,
	"./SpinGeneral_007.webp": 99722,
	"./SpinGeneral_008.webp": 22753,
	"./SpinGeneral_009.webp": 30276,
	"./SpinGeneral_010.webp": 61513,
	"./SpinGeneral_011.webp": 63702,
	"./SpinGeneral_012.webp": 2640,
	"./SpinGeneral_013.webp": 94247,
	"./SpinGeneral_014.webp": 99599,
	"./SpinGeneral_015.webp": 35346,
	"./SpinGeneral_016.webp": 81253,
	"./SpinGeneral_017.webp": 12930,
	"./SpinGeneral_018.webp": 87338,
	"./SpinGeneral_019.webp": 60098,
	"./SpinGeneral_020.webp": 95590,
	"./SpinGeneral_021.webp": 68517,
	"./SpinGeneral_022.webp": 83867,
	"./SpinGeneral_023.webp": 44293,
	"./SpinGeneral_024.webp": 22254,
	"./SpinGeneral_025.webp": 42551,
	"./SpinGeneral_026.webp": 57601,
	"./SpinGeneral_027.webp": 83569,
	"./SpinGeneral_028.webp": 58800,
	"./SpinGeneral_029.webp": 46579,
	"./SpinGeneral_030.webp": 74246,
	"./SpinGeneral_031.webp": 35500,
	"./SpinGeneral_032.webp": 82369,
	"./SpinGeneral_033.webp": 91321,
	"./SpinGeneral_034.webp": 59309,
	"./SpinGeneral_035.webp": 80668,
	"./SpinGeneral_036.webp": 57690,
	"./SpinGeneral_037.webp": 30512,
	"./SpinGeneral_038.webp": 22474,
	"./SpinGeneral_039.webp": 27906,
	"./SpinGeneral_040.webp": 48278,
	"./SpinGeneral_041.webp": 65425,
	"./SpinGeneral_042.webp": 5605,
	"./SpinGeneral_043.webp": 97391,
	"./SpinGeneral_044.webp": 32743,
	"./SpinGeneral_045.webp": 22645,
	"./SpinGeneral_046.webp": 40753,
	"./SpinGeneral_047.webp": 33064,
	"./SpinGeneral_048.webp": 2495,
	"./SpinGeneral_049.webp": 15471,
	"./SpinGeneral_050.webp": 76678,
	"./SpinGeneral_051.webp": 65667,
	"./SpinGeneral_052.webp": 74329,
	"./SpinGeneral_053.webp": 93294,
	"./SpinGeneral_054.webp": 3411,
	"./SpinGeneral_055.webp": 28465,
	"./SpinGeneral_056.webp": 69087,
	"./SpinGeneral_057.webp": 10610,
	"./SpinGeneral_058.webp": 51385,
	"./SpinGeneral_059.webp": 75711,
	"./SpinGeneral_060.webp": 47239,
	"./SpinGeneral_061.webp": 40589,
	"./SpinGeneral_062.webp": 99357,
	"./SpinGeneral_063.webp": 67447,
	"./SpinGeneral_064.webp": 77539,
	"./SpinGeneral_065.webp": 23362,
	"./SpinGeneral_066.webp": 63939,
	"./SpinGeneral_067.webp": 18019,
	"./SpinGeneral_068.webp": 35533,
	"./SpinGeneral_069.webp": 11902,
	"./SpinGeneral_070.webp": 90477,
	"./SpinGeneral_071.webp": 93643,
	"./SpinGeneral_072.webp": 95285
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32652;